"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("../../shared/validators/GenericValidator"));
class ClientRegistrationValidator extends GenericValidator_1.default {
    schema = joi_1.default.object({
        id: joi_1.default.string(),
        secret: joi_1.default.string(),
        orgKey: joi_1.default.string().required(),
        productAccess: joi_1.default.object().required(),
        permissions: joi_1.default.object().required(),
        created: joi_1.default.number().required(),
        referrerHosts: joi_1.default.array()
            .items(joi_1.default.string())
            .min(0)
            .unique()
            .required(),
        expirationDate: joi_1.default.number().allow(null),
    }).required();
    validate(input) {
        super.validate(input, 'IClientRegistration', this.schema);
    }
}
exports.default = ClientRegistrationValidator;
